import React from "react";
import DosOverTimeReport from "./Report";
import View from "common/View";
import Help from "./Help";

const DoSOverTimeStats = () =>
  <View title="DoS attacks over time" Help={Help}>
    <DosOverTimeReport />
  </View>

export default DoSOverTimeStats;
